package com.exura.features.plandefinition.data.mappers.plandefinition

import com.exura.features.plandefinition.data.remote.dto.plan.BasePlanDto
import com.exura.features.plandefinition.data.remote.dto.plan.PreparationPlanDto
import com.exura.features.plandefinition.data.remote.dto.plan.TreatmentPlanDto
import com.exura.features.plandefinition.data.remote.dto.series.*
import com.exura.features.plandefinition.domain.model.element.BasePlanElement
import com.exura.features.plandefinition.domain.model.plan.BasePlan
import com.exura.features.plandefinition.domain.model.plan.PreparationPlan
import com.exura.features.plandefinition.domain.model.plan.TreatmentPlan
import com.exura.features.plandefinition.domain.model.series.*
import dev.gitlive.firebase.firestore.CollectionReference

class PolymorphicPlanMappers: PlanMappers<BasePlan, BasePlanDto> {
    override fun toDto(model: BasePlan): BasePlanDto {
        return when (model) {
            is TreatmentPlan -> TreatmentPlanMappers().toDto(model)
            is PreparationPlan -> PreparationPlanMappers().toDto(model)
            else -> throw IllegalArgumentException("Unknown plan type: ${model::class.simpleName}")
        }
    }

    override fun toDomain(
        dto: BasePlanDto,
        collection: CollectionReference?,
        id: String?
    ): BasePlan  {
        return when (dto) {
            is TreatmentPlanDto -> TreatmentPlanMappers().toDomain(dto, collection, id)
            is PreparationPlanDto -> PreparationPlanMappers().toDomain(dto, collection, id)
            else -> throw IllegalArgumentException("Unknown plan type: ${dto::class.simpleName}")
        }
    }
}
